const offerSchema = (data, urlProduct) => {
  var _data$price, _data$price2, _data$price3, _data$price4;

  if (!data || Object.keys(data).length === 0 || !urlProduct || !data.price || !(data != null && (_data$price = data.price) != null && _data$price.bestPrice) && !(data != null && (_data$price2 = data.price) != null && _data$price2.price)) return null;
  return {
    '@type': 'Offer',
    price: (data == null ? void 0 : (_data$price3 = data.price) == null ? void 0 : _data$price3.bestPrice) || (data == null ? void 0 : (_data$price4 = data.price) == null ? void 0 : _data$price4.price),
    priceCurrency: 'BRL',
    availability: 'http://schema.org/InStock',
    url: (data == null ? void 0 : data.offer) || urlProduct
  };
};

export default offerSchema;